"use client";

import { motion } from "framer-motion";

/* ================= IMAGES ================= */
import duffelBagImg from "../../assets/images/expedition-gear/duffel-bag/gearImg21.png";
import duffelBagImg2 from "../../assets/images/expedition-gear/duffel-bag/gearImg22.png";
import duffelBagImg3 from "../../assets/images/expedition-gear/duffel-bag/gearImg15.png";
import gearTentImg1 from "../../assets/images/expedition-gear/tent/gearTentImg1.png";
import gearTentImg2 from "../../assets/images/expedition-gear/tent/gearTentImg2.png";
import gearTentImg3 from "../../assets/images/expedition-gear/tent/gearTentImg3.png";
import gearTentImg4 from "../../assets/images/expedition-gear/tent/gearTentImg4.png";
import gearTentImg5 from "../../assets/images/expedition-gear/tent/gearTentImg5.png";
import gearTentImg6 from "../../assets/images/expedition-gear/tent/gearTentImg6.png";

import gearCapImg1 from "../../assets/images/expedition-gear/caps/gearCapImg1.png";
import gearCapImg2 from "../../assets/images/expedition-gear/caps/gearCapImg2.png";
import gearCapImg3 from "../../assets/images/expedition-gear/caps/gearCapImg3.png";
import gearCapImg4 from "../../assets/images/expedition-gear/caps/gearCapImg4.png";
import gearCapImg5 from "../../assets/images/expedition-gear/caps/gearCapImg5.png";
import gearCapImg6 from "../../assets/images/expedition-gear/caps/gearCapImg10.png";
import gearImgBackground from "../../assets/images/expedition-gear/backgroundImage.png";


/* ================= DATA ================= */
const EQUIPMENT_SECTIONS = [
      {
    title: "BroadBoy High-Altitude Tents",
    description:
      "Engineered shelters built for wind resistance, snow load, and extreme environments.",
    images: [
      gearTentImg3,
      gearTentImg6,
      gearTentImg2,
      gearTentImg4,
      gearTentImg1,
      gearTentImg5,
    ],
  },
      {
    title: "BroadBoy Expedition Duffel Bags",
    description:
      "Rugged expedition duffels designed to carry heavy loads across harsh terrain.",
    images: [
      duffelBagImg,
      duffelBagImg3,
      duffelBagImg2
    ],
  },
    {
    title: "BroadBoy Expedition Caps",
    description:
      "Performance headwear designed for exposure, long days, and alpine conditions.",
    images: [
      gearCapImg2,
      gearCapImg1,
      gearCapImg3,
      gearCapImg5,
      gearCapImg6,
      gearCapImg4,
    ],
  }
];

/* ================= COMPONENT ================= */
export default function BroadBoyEquipmentGallery() {
  return (
    <section className="relative w-full py-32 bg-[#f4f5f7] overflow-hidden"
        style={{ backgroundImage: `url(${gearImgBackground})` }}
    >
           
          <div className="relative z-10 text-center max-w-4xl mx-auto px-6 pb-20 text-[#192c37]">
            <h1 className="text-4xl md:text-5xl font-extrabold">
                BroadBoy Adventures Equipment
            </h1>

            <p className="mt-6 text-[#192c37]/80">
                Official BroadBoy Adventures branding equipments built for real
                high-altitude performance.
            </p>

          </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-32">

        {EQUIPMENT_SECTIONS.map((section, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="space-y-10"
          >
            {/* ================= HEADER ================= */}
            <div className="text-center max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-semibold text-[#091922]">
                {section.title}
              </h2>

              <p className="mt-4 text-gray-600 leading-relaxed">
                {section.description}
              </p>
            </div>

            {/* ================= IMAGE GRID ================= */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {section.images.map((img, imgIndex) => (
                <div
                  key={imgIndex}
                  className="
                    group
                    relative
                    rounded-3xl
                    overflow-hidden
                    bg-white
                    shadow-sm
                    hover:shadow-lg
                    transition
                  "
                >
                  <div className="aspect-[4/5] overflow-hidden">
                    <img
                      src={img}
                      alt={`${section.title} ${imgIndex + 1}`}
                      className="
                        w-full h-full object-cover
                        transition-transform duration-500
                        group-hover:scale-105
                      "
                    />
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        ))}

      </div>
    </section>
  );
}
